import React from 'react';
import { BrowserRouter, Routes as RouterRoutes, Route, Navigate } from 'react-router-dom';

import ErrorBoundary from './components/ErrorBoundary';
import ScrollToTop from './components/ScrollToTop';



import ProtectedRoute from './components/ProtectedRoute';
import PartnerProtectedRoute from './components/PartnerProtectedRoute';

// Analytics Pages
import UserManagement from './pages/user-management';
import UserAnalyticsTable from './pages/user-analytics-table';
import OfferManagement from './pages/offer-management';
import ExecutiveOverview from './pages/executive-overview';
import RedemptionAnalytics from './pages/redemption-analytics';


// Partner Pages
import PartnerManagementDashboard from './pages/partner-management-dashboard';
import PartnerDashboard from './pages/partner-dashboard';
import PartnerCreateOffer from './pages/partner-create-offer';
import PartnerOfferManagement from './pages/partner-offer-management';
import PartnerOnboardingWorkflow from './pages/partner-onboarding-workflow';
import PartnerAcquisition from './pages/partner-acquisition';
import PartnerAcquisitionPipeline from './pages/partner-acquisition-pipeline';
import PartnerOnboardingCalls from './pages/partner-onboarding-calls';
import PartnerCredentials from './pages/partner-credentials';

// Auth Pages
import Login from './pages/auth/Login';
import Signup from './pages/auth/Signup';
import PartnerLogin from './pages/partner-login';
import PartnerPasswordReset from './pages/partner-password-reset';
import PartnerPasswordSetup from './pages/partner-password-setup';
import PasswordResetForm from './pages/password-reset-form';

// 404 Page
import NotFound from './pages/NotFound';

// QR Code Management
import QRCodeManagement from './pages/qr-code-management';

// Admin Pages
import AdminCreateOffer from './pages/admin-create-offer';

import PublicPartnerApplicationForm from './pages/public-partner-application-form';
import PartnerCalendarScheduling from './pages/partner-calendar-scheduling';
import MagicLinkConfirmation from './pages/magic-link-confirmation';
import PartnerPasswordManagement from './pages/partner-password-management';

function Routes() {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Redirect root to executive overview */}
          <Route path="/" element={<Navigate to="/executive-overview" replace />} />
          
          {/* ============================================ */}
          {/* ADMIN & USER AUTHENTICATION ROUTES */}
          {/* ============================================ */}
          <Route path="/auth/login" element={<Login />} />
          <Route path="/auth/signup" element={<Signup />} />
          <Route path="/reset-password" element={<PasswordResetForm />} />
          
          {/* ============================================ */}
          {/* PARTNER AUTHENTICATION ROUTES */}
          {/* ============================================ */}
          <Route path="/partner-login" element={<PartnerLogin />} />
          <Route path="/partner-password-reset" element={<PartnerPasswordReset />} />
          <Route path="/partner-password-setup" element={<PartnerPasswordSetup />} />
          
          {/* ============================================ */}
          {/* PUBLIC ROUTES (NO AUTHENTICATION) */}
          {/* ============================================ */}
          <Route path="/public-partner-application-form" element={<PublicPartnerApplicationForm />} />
          <Route path="/partner-calendar-scheduling" element={<PartnerCalendarScheduling />} />
          <Route path="/partner-calendar-scheduling/:partnerId" element={<PartnerCalendarScheduling />} />
          
          {/* ============================================ */}
          {/* PARTNER-ONLY ROUTES (Partners table authentication) */}
          {/* ============================================ */}
          <Route element={<PartnerProtectedRoute />}>
            <Route path="/partner-dashboard" element={<PartnerDashboard />} />
            <Route path="/partner-offer-management" element={<PartnerOfferManagement />} />
            <Route path="/partner-create-offer" element={<PartnerCreateOffer />} />
          </Route>
          
          {/* ============================================ */}
          {/* ADMIN & USER ROUTES (Supabase auth.users authentication) */}
          {/* ============================================ */}
          <Route element={<ProtectedRoute />}>
            {/* Admin Management Routes */}
            <Route path="/user-management" element={<UserManagement />} />
            <Route path="/user-analytics-table" element={<UserAnalyticsTable />} />
            <Route path="/qr-code-management" element={<QRCodeManagement />} />
            <Route path="/partner-management-dashboard" element={<PartnerManagementDashboard />} />
            <Route path="/partner-acquisition" element={<PartnerAcquisition />} />
            <Route path="/partner-acquisition-pipeline" element={<PartnerAcquisitionPipeline />} />
            <Route path="/partner-onboarding-workflow" element={<PartnerOnboardingWorkflow />} />
            <Route path="/partner-onboarding-calls" element={<PartnerOnboardingCalls />} />
            
            {/* Analytics & Dashboard Routes */}
            <Route path="/offer-management" element={<OfferManagement />} />
            <Route path="/executive-overview" element={<ExecutiveOverview />} />
            <Route path="/redemption-analytics" element={<RedemptionAnalytics />} />
            <Route path="/admin-create-offer" element={<AdminCreateOffer />} />
          </Route>

          {/* Magic Link Confirmation */}
          <Route path="/magic-link-confirmation" element={<MagicLinkConfirmation />} />
          
          {/* Partner Password Management */}
          <Route 
            path="/partner-password-management" 
            element={
              <PartnerProtectedRoute>
                <PartnerPasswordManagement />
              </PartnerProtectedRoute>
            } 
          />
          
          {/* Partner Credentials Route */}
          <Route
            path="/partner-credentials"
            element={
              <ProtectedRoute>
                <PartnerCredentials />
              </ProtectedRoute>
            }
          />
          
          {/* 404 Route */}
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
}

export default Routes;